// fetch from external API endpoint

import { getBaseQuery } from '@/utils/apiHelper'
import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

export const instagramFeedApi = createApi({
  reducerPath: 'instagramFeed',
  baseQuery: getBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getFeed: builder.query<any, void>({
      query: () => `instagramFeed`,
    }),
  }),
})

export const { useGetFeedQuery } = instagramFeedApi
export const { getFeed } = instagramFeedApi.endpoints